export const ORDER_CHECKOUT_REQUEST = 'order_checkout_request'
export const ORDER_CHECKOUT_RESPONSE = 'order_checkout_response'
export const ORDER_PAYMENT_REQUEST = 'order_payment_request'
export const ORDER_PAYMENT_RESPONSE = 'order_payment_response'
export const UPDATE_ORDER_REQUEST = 'update_order_request'
export const UPDATE_ORDER_RESPONSE = 'update_order_response'
export const ORDER_ERROR = 'order_error'
